import aria from './aria.json' with { type: 'json' };
import badges from './badges.json' with { type: 'json' };
import buttons from './buttons.json' with { type: 'json' };
import components from './components';
import errors from './errors.json' with { type: 'json' };
import labels from './labels.json' with { type: 'json' };
import links from './links.json' with { type: 'json' };
import placeholders from './placeholders.json' with { type: 'json' };
import tables from './tables.json' with { type: 'json' };
import titles from './titles.json' with { type: 'json' };

/**
 * The generic namespaces the primitives translate against.
 *
 * This package does not own an i18next instance. Whoever does merges these in
 * alongside its own namespaces. See `@sparklayer-io/spark-dash-pages/i18n`.
 */
export default {
  aria,
  badges,
  buttons,
  components,
  errors,
  labels,
  links,
  placeholders,
  tables,
  titles,
};
